import React from "react";

import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import MaintenanceForm from "./MaintenanceForm";

type MaintenanceFormDialogProps = {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
};

const MaintenanceFormDialog: React.FC<MaintenanceFormDialogProps> = ({
  showDialog,
  setShowDialog,
}) => {
  return (
    <Dialog
      header={T("mdm.maintenance")}
      visible={showDialog}
      onHide={() => setShowDialog(false)}
      style={{ width: "min(100vw, 1000px)", height: "400x" }}
      resizable
      modal
    >
      <MaintenanceForm closeDialog={() => setShowDialog(false)} />
    </Dialog>
  );
};

export default MaintenanceFormDialog;
